// @ts-ignore
import numeral from 'numeral';
import { useIntl, createIntl, createIntlCache } from 'react-intl';
import store from 'state/store';
import selectors from 'state/selectors';
import { UserDecimalSep } from 'models/user';
import { useCallback } from 'react';
import { SaveDocumentQ1FieldValue } from 'models/request';
import { Q1Value } from 'models/documents';

const cache = createIntlCache();

function translate(label: string) {
  const language = navigator.language.split('-')[0];
  const intl = createIntl(
    {
      locale: language,
      messages: window.appIntl ?? {},
    },
    cache,
  );
  return intl.formatMessage({ id: `${label}.localKeyValue` });
}

// hooks used to translate labels
const useTranslator = () => {
  const t = useIntl();
  return useCallback((label: string) => t.formatMessage({ id: `${label}.localKeyValue` }), [t]);
};

const formatNumber = (num: number, decimalScale: number | undefined, separator?: UserDecimalSep): string => {
  const precision = typeof decimalScale === 'number' ? decimalScale : 2;

  const decimalSep = separator ?? selectors.user.getUserPreference(store.getState()).decimalSep;
  const formatString = `0.${'0'.repeat(precision)}`;

  if (decimalSep === '.') {
    return numeral(num).format(formatString);
  }
  return numeral(num)
    .format(formatString)
    .replace(/\.(\d+)$/, ',$1');
};

const convertToNumber = (num: string): number => {
  return parseFloat(num.replace(',', '.'));
};

const formatCurrencyField = (field: Q1Value, decimal: number) => {
  const { content } = field;

  const newContent: SaveDocumentQ1FieldValue[] = content.map((ele) => {
    return {
      ...ele,
      content: ele.content ? formatNumber(convertToNumber(ele.content), decimal, ',') : '',
    };
  });

  const newValue = {
    ...field,
    content: newContent,
  };

  return newValue;
};

export default {
  formatNumber,
  useTranslator,
  convertToNumber,
  translate,
  formatCurrencyField,
};
